export default __webpack_public_path__ + "assets/audios/2f78a206af8d85bb336b5e5c8d2f36aa.mp3";